/**
 * Firebase App Check Configuration for Landing Page
 * Local copy to avoid CommonJS import issues with Vite
 */

const APP_CHECK_NONPROD = {
  landing: {
    siteKey: '6LfjfgEsAAAAAFt1OPNb8fYoB-T8kC2U_DKLwFGg',
    isTokenAutoRefreshEnabled: true,
  },
} as const;

const APP_CHECK_PROD = {
  landing: {
    siteKey: '6LeGnQEsAAAAAKESsCcs7aW8bSNK41Qj4RuHIaFj',
    isTokenAutoRefreshEnabled: true,
  },
} as const;

// Select correct config based on environment
export const APP_CHECK_CONFIG = import.meta.env.VITE_ENVIRONMENT === 'prod' 
  ? APP_CHECK_PROD 
  : APP_CHECK_NONPROD;

